import { FormikProvider, Formik, useFormik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import AutocompleteV2 from "../../component/AutocompleteObjectV2";
import LabelRequired from "../../component/LabelRequired";
import TextField from "../../component/TextField";
import { IConnect } from "../models/ConnectModels";
import { CODE, KEY } from '../../utils/Constant';
import { addKn, detailKn, searchDanhSachPhanMem } from "../services/services";
import { searchDanhSachDV } from "../../organization/services/services";
import { searchDanhSachDichVu } from "../../services/services/services";

type Props = {
  handleClose: (isBackHomePage?: boolean) => void;
  rowData: IConnect;
};

const OrganizationDetailDialog = (props: Props) => {
  const { handleClose, rowData } = props;
  const intl = useIntl();
  const [initialValues, setInitialValues] = React.useState<IConnect>({
    id: "",
    orgProvideId: "",
    orgProvideCode: "",
    orgProvideName: "",
    orgProvide: null,
    orgId: "",
    orgCode: "",
    orgName: "",
    org: null,
    serviceId: "",
    serviceCode: "",
    service: null,
    functionId: "",
    functionCode: "",
    systemId: "",
    systemCode: "",
    system: null,
    endpointUrl: "",
    method: "",
    protocol: "",
    description: "",
    isActive: true,
    cRequestHttpReqDto: null,
  });
  const formRef = useRef<any>(null);
  const [phanMemList, setPhanMemList] = useState<any>([]);
  const [requestValues, setRequestValues] = useState<any>();
  const validationSchema = Yup.object({});

  useEffect(() => {
    getListPhanMem();
  }, []);

  useEffect(() => {
    if (rowData?.id) {
      getDetail(rowData.id);
    } else {
      formRef?.current?.resetForm();
    }
  }, [rowData]);

  useEffect(() => {
    formik.setFieldValue("cRequestHttpReqDto", {
      ...requestValues,
    });
  }, [requestValues]);

  const getDetail = async (id: string) => {
    try {
      const res = await detailKn(id);
      
      if (res?.data?.code === CODE.SUCCESS) {
        var data = {
          ...res?.data?.data,
          org: {
            id: res?.data?.data?.orgId,
            code: res?.data?.data?.orgCode,
            name: res?.data?.data?.orgName,
          },
          orgProvide: {
            id: res?.data?.data?.orgProvideId,
            code: res?.data?.data?.orgProvideCode,
            name: res?.data?.data?.orgProvideName,
          },
          system: {
            id: res?.data?.data?.systemId || "",
            code: res?.data?.data?.systemCode || "",
            name: res?.data?.data?.systemName || "",
          },
          service: {
            id: res?.data?.data?.serviceId || "",
            code: res?.data?.data?.serviceCode || "",
            name: res?.data?.data?.serviceName || "",
          },
        }
        setRequestValues({
          ...res?.data?.data?.cRequestHttpReqDto,
        });
        formik.setValues(data);
        toast.success(intl.formatMessage({ id: "TOAST.GET.SUCCESS" }));
      } else {
        toast.error(`${res?.data?.message}`);
      }
    } catch (err) {
      toast.error(intl.formatMessage({ id: "TOAST.GET.ERROR" }));
    }
  };

  const getListPhanMem = async () => {
    try {
      const { data } = await searchDanhSachPhanMem({
        orgProvideCode: formik?.values?.orgProvideCode || null,
        isActive: true,
        pageSize: 999,
        pageIndex: 1,
      });

      if (CODE.SUCCESS === data.code) {
        var tableData = data.data.content.map((item: any, index: number) => ({
          ...item,
        }));
        setPhanMemList(
          tableData
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (values: IConnect) => {
    let _values = {
      ...values,
      cRequestHttpReqDto: {
        ...requestValues,
        description: values?.description,
      },
    };

    try {
      const res = await addKn(_values);
      if (res?.data?.code === CODE.SUCCESS) {
        toast.success(
          rowData?.id
            ? intl.formatMessage({ id: "TOAST.EDIT.SUCCESS" })
            : intl.formatMessage({ id: "TOAST.CREATE.SUCCESS" })
        );
        handleClose();
      } else {
        toast.error(`${res?.data?.message}`);
      }
    } catch (err) {
      toast.error(intl.formatMessage({ id: "GENERAL.ERROR" }));
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  const handleChange = (name: string, value: any) => {
    switch (name) {
      case "org":
        formik.setFieldValue("orgId", value?.id);
        formik.setFieldValue("orgCode", value?.code);
        formik.setFieldValue("orgName", value?.name);
        break;
      case "orgProvide":
        formik.setFieldValue("orgProvideId", value?.id);
        formik.setFieldValue("orgProvideCode", value?.code);
        formik.setFieldValue("orgProvideName", value?.name);
        setRequestValues({
          ...requestValues,
          provider: value,
        });
        break;
      case "service":
        formik.setFieldValue("serviceId", value?.id);
        formik.setFieldValue("serviceCode", value?.code);
        break;
      case "system":
        formik.setFieldValue("systemId", value?.id);
        formik.setFieldValue("systemCode", value?.code);
        break;
      default:
        formik.setFieldValue(name, value);
        break;
    }
  };

  const handleChangeRequest = (name: string, value: any) => {
    setRequestValues({
      ...requestValues,
      [name]: value,
    });
  };

  return (
    <Modal show={true} centered onHide={() => handleClose(false)} size="xl">
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton className="header-modal">
            <Modal.Title className="text-pri ">Thông tin kết nối</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Col lg={3}>
                <TextField
                  label={<LabelRequired isRequired label="Url" />}
                  name={"endpoint Url"}
                  type={"text"}
                  value={formik?.values?.endpointUrl}
                />
              </Col>
              <Col lg={3}>
                <TextField
                  label={<LabelRequired isRequired label="Phương thức" />}
                  name={"method"}
                  type={"text"}
                  value={formik?.values?.method}
                />
              </Col>
              <Col lg={3}>
                <TextField
                  label={<LabelRequired isRequired label="Giao thức" />}
                  name={"protocol"}
                  type={"text"}
                  value={formik?.values?.protocol}
                />
              </Col>
              <Col lg={3}>
                <TextField
                  label={<LabelRequired isRequired label="Mô tả" />}
                  name={"description"}
                  type={"text"}
                  value={formik?.values?.description}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={3}>
                <LabelRequired isRequired label="Đơn vị sử dụng" />
                <AutocompleteV2
                  options={[]}
                  getOptionLabel={(option: any) => `${option?.name}`}
                  isSearchDefauilt={true}
                  name={"org"}
                  isClearable={false}
                  onChange={(options: any) => {
                    handleChange("org", options)
                  }}
                  value={formik?.values?.org}
                  className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                  searchFunction={searchDanhSachDV}
                  searchObject={{
                    pageSize: 999,
                    pageIndex: 1,
                  }}
                  errors={formik?.errors?.org}
                  touched={formik?.touched?.org}
                />
              </Col>
              <Col lg={3}>
                <LabelRequired isRequired label="Đơn vị cung cấp" />
                <AutocompleteV2
                  options={[]}
                  getOptionLabel={(option: any) => `${option?.name}`}
                  isSearchDefauilt={true}
                  name={"orgProvide"}
                  isClearable={false}
                  onChange={(options: any) => {
                    handleChange("orgProvide", options)
                  }}
                  value={formik?.values?.orgProvide}
                  className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                  searchFunction={searchDanhSachDV}
                  searchObject={{
                    pageSize: 999,
                    pageIndex: 1,
                  }}
                  errors={formik?.errors?.orgProvide}
                  touched={formik?.touched?.orgProvide}
                />
              </Col>
              <Col lg={3}>
                <LabelRequired isRequired label="Dịch vụ" />
                <AutocompleteV2
                  options={[]}
                  getOptionLabel={(option: any) => `${option?.name}`}
                  isSearchDefauilt={true}
                  name={"service"}
                  isClearable={false}
                  onChange={(options: any) => {
                    handleChange("service", options)
                  }}
                  value={formik?.values?.serviceId}
                  className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                  searchFunction={searchDanhSachDichVu}
                  searchObject={{
                    pageSize: 999,
                    pageIndex: 1,
                  }}
                  errors={formik?.errors?.service}
                  touched={formik?.touched?.service}
                />
              </Col>
              <Col lg={3} className="mb-3">
                <LabelRequired isRequired label="Phần mềm" />
                <AutocompleteV2
                  options={phanMemList}
                  isSearchDefauilt={true}
                  getOptionLabel={(option: any) => `${option?.systemName}`}
                  name={"system"}
                  onChange={(options: any) => {
                    handleChange("system", options);
                  }}
                  value={formik?.values?.systemId}
                  className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                  errors={formik?.errors?.system}
                  touched={formik?.touched?.system}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={3}>
                <TextField
                  label={<LabelRequired label="Params" />}
                  name={"params"}
                  type={"text"}
                  value={formik?.values?.cRequestHttpReqDto?.params}
                  onChange={(e: any) => {
                    handleChangeRequest(e.target.name, e.target.value)
                  }}
                />
              </Col>
              <Col lg={3}>
                <TextField
                  label={<LabelRequired label="Path variable" />}
                  name={"pathVariable"}
                  type={"text"}
                  value={formik?.values?.cRequestHttpReqDto?.pathVariable}
                  onChange={(e: any) => {
                    handleChangeRequest(e.target.name, e.target.value)
                  }}
                />
              </Col>
              <Col lg={3}>
                <TextField
                  label={<LabelRequired label="Content type" />}
                  name={"contentType"}
                  type={"text"}
                  value={formik?.values?.cRequestHttpReqDto?.contentType}
                  onChange={(e: any) => {
                    handleChangeRequest(e.target.name, e.target.value)
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <TextField
                  label={<LabelRequired label="Body" />}
                  name={"body"}
                  type={"text"}
                  as="textarea"
                  className="min-h-100px max-h-200px"
                  value={formik?.values?.cRequestHttpReqDto?.body}
                  onChange={(e: any) => {
                    handleChangeRequest(e.target.name, e.target.value)
                  }}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              className="btn-fill mx-3 spaces min-w-90px btn btn-primary"
            >
              Lưu
            </Button>
            <Button
              variant="btn-fill spaces mx-3 min-w-90px btn btn-secondary"
              onClick={() => handleClose(false)}
            >
              Hủy
            </Button>
          </Modal.Footer>
        </Form>
      </FormikProvider>
    </Modal>
  );
};

export default OrganizationDetailDialog;
